/**
 @ngdoc controller
 @name BulkEditCtrl

 @description
 This controller is used to bulk edit rows

 */
(function() {
    'use strict';
    var BulkEditCtrl = function($scope, $compile, ajaxCall, $filter, $timeout, xmsNotificationFactory, keyValueObjectService, progressBarService) {

        $scope.DEBUG = false;
        if($scope.DEBUG){
            console.log('BulkEditCtrl loaded');
            console.log('$scope',$scope);
        }

        $scope.bulkEditModel = {
            filter:{}
        };

        $scope.bulkEdit = {
            editableField: '',
            user: {
                /**
                 * Information about what's been selected
                 * example: {"colKey":"endDate","rowIdSet":{"275":true}}
                 */
                selected: {
                    editingAll: false,
                    colKey: null,
                    rowIdSet: {}
                },
                /**
                 * IInformation about what's being edited
                 * example: {"rowIdSet":{"275":true}}
                 */
                edited: {
                    rowIdSet: {}
                }
            },
            /**
             * Data Model
             * {
             *      headerLabels: {
             *          {key}: { label: String, editable: Boolean, dataType: String,  } ,
             *          {key}: { label: String, editable: Boolean, dataType: String } ,
             *          ...
             *      },
             *      dataList: [
             *          { {key}: {value: String, editable: Boolean, ... } } ,
             *          { {key}: {value: String, editable: Boolean, ... } } ,
             *          ...
             *      ],
             *      dataInformation: { }
             * }
             */
            sourceData: null,
            /**
             * data being filtered for display
             */
            filteredDataList: [],
            removeData : false

        };
        $scope.ajaxState = 'PAUSED';
        $scope.filterConditionOptions = {};
        $scope.filterConditionOptionsSetup = {};
        /**
         * css model
         */
        $scope.css;
        /**
         * Supported Format Types ~ Also indicates filterType
         * @type {{STRING: {inputType: string}, NUMBER: {inputType: string}, MONETARY_WITH_RATE: {inputType: string}, DATE: {inputType: string}, DATE_TIME: {inputType: string}, TIME: {inputType: string}}}
         */
        $scope.DATA_FORMAT_TYPE = {
            "STRING":{inputType:'text'},
            "NUMBER":{inputType:'number'},
            "MONETARY_WITH_RATE":{inputType:'number'},
            "DATE":{inputType:'date'},
            "DATE_TIME":{inputType:'date'},
            "TIME":{inputType:'time'}
        };
        /**
         * Add or removes row id from a set if being edited
         * @param rowId
         * @param edited
         */
        var editSet = function(rowId, edited){
            if(edited){
                $scope.bulkEdit.user.edited.rowIdSet[rowId] = true;
            } else {
                delete $scope.bulkEdit.user.edited.rowIdSet[rowId];
            }
        };
        var countEditedRows = function(){
            return Object.keys($scope.bulkEdit.user.edited.rowIdSet).length;
        };
        var isColumnEditable = function(colVal){
            return colVal.editable;
        };
        var isSameColumn = function(colKey){
            //console.log('isSameColumn', ( $scope.bulkEdit.user.selected.colKey === colKey ));
            return ( $scope.bulkEdit.user.selected.colKey === colKey );
        };
        var isRowEditable = function(colKey, row){
            return row[colKey].editable;
        };
        var isCellEditable = function(colKey, colVal, row){
            return ( isColumnEditable(colVal) && isRowEditable(colKey, row) );
        };
        var isCellSelected = function(colKey, rowId){
            return ( $scope.bulkEdit.user.selected.colKey === colKey && $scope.bulkEdit.user.selected.rowIdSet.hasOwnProperty(rowId) );
        };
        var isCellEdited = function(colKey, row){
            //console.log('isCellEdited',( row[colKey].value !== row[colKey].VALUE ));
            return ( row[colKey].value !== row[colKey].origValue );
        };
        var isCellHighlightingEntriesAndEntryMade = function(colKey, row){
            return ( $scope.bulkEdit.sourceData.headerLabels[colKey].highlightEntries && row[colKey].value.length>0 );
        };
        var clearAllSelectedCells = function(){
            $scope.bulkEdit.user.selected.colKey = null;
            $scope.bulkEdit.user.selected.rowIdSet = {};
            dataSelectionChange();
        };
        var selectAllVisibleCells = function(colKey, colVal, displayedRows){
            if( selectCol(colKey, colVal) ) {
                var rowSelected;
                for (var idx in displayedRows) {
                    rowSelected = selectRow(colKey, displayedRows[idx]);
                }
            }
        };
        var deselectAllVisibleCells = function(colKey,displayedRows){
            for(var idx in displayedRows) {
                deselectRow(displayedRows[idx].id.value);
            }
        };
        var toggleAllCells = function(colKey,colVal,rows) {
            selectCol(colKey, colVal);
            var cellCount = countEditableAndSelectedCells(colKey, colVal, rows);
            if( cellCount.editable == cellCount.selected ){
                deselectAllVisibleCells(colKey,rows);
            } else {
                selectAllVisibleCells(colKey,colVal,rows);
            }
        };
        var countCurrentSelection = function(){
            return Object.keys($scope.bulkEdit.user.selected.rowIdSet).length;
        };
        var countDataRowSize = function(){
            $scope.bulkEdit.sourceData.dataList.length;
        };
        var isFullDataSet = function(rows){
            return (rows.length == countDataRowSize());
        };
        var countEditableAndSelectedCells = function(colKey, colVal, rows){
            var cellCount = {editable: 0, selected: 0};
            //if the column is not editable... nothings going to be selected or editable
            if( isColumnEditable(colVal) ){
                var allRows = isFullDataSet(rows);
                var sameColumn = isSameColumn(colKey);
                if(allRows && sameColumn){
                    cellCount.editable = colVal.noOfEditable;
                    cellCount.selected = countCurrentSelection();
                } else {
                    var row;
                    //loop through counting
                    for (var idx in rows) {
                        row = rows[idx];
                        if (row[colKey].editable) {
                            cellCount.editable++;
                            if (sameColumn && !allRows && $scope.bulkEdit.user.selected.rowIdSet[row.id.value]) {
                                cellCount.selected++;
                            }
                        }
                    }
                }
            }
            return cellCount;
        };
        /**
         * Selects the column if the column is selectable
         * @param colKey
         * @returns boolean has column been selected
         */
        var selectCol = function(colKey, colVal) {
            var editable = isColumnEditable(colVal);
            if(editable) {
                if(!isSameColumn(colKey)){
                    clearAllSelectedCells();
                }
                $scope.bulkEdit.user.selected.colKey = colKey;
                dataSelectionChange();
            }
            return editable
        };
        var selectRow = function(colKey, row) {
            var editable = isRowEditable(colKey, row);
            if(editable) {
                $scope.bulkEdit.user.selected.rowIdSet[row.id.value] = true;
            }
            return editable;
        };
        var deselectRow = function(rowId) {
            delete $scope.bulkEdit.user.selected.rowIdSet[rowId];
        };
        var log = function(identifier,data){
            if($scope.DEBUG) {
                console.log(identifier,data);
            }
        };
        /**
         * Selects the column if the column is selectable and row if selectable
         * @param colKey
         * @param colVal
         * @param row
         * @returns {boolean} has cell been selected
         */
        var selectCell = function(colKey, colVal, row){
            var cellSelected = selectCol(colKey, colVal);
            if( cellSelected ){
                cellSelected = selectRow(colKey, row);
            }
            return cellSelected;
        };

        var deselectCell = function(colKey, rowId){
            deselectRow(rowId);
        };
        var toggleCell = function(colKey, colVal, row){
            if( isCellEditable(colKey, colVal, row) ) {
                //.id.value
                if (isCellSelected(colKey, row.id.value)) {
                    deselectCell(colKey, row.id.value);
                } else {
                    selectCell(colKey, colVal, row);
                }
            }
        };
        var dataSelectionChange = function(){
            log('dataSelectionChange()','');
        };
        /**
         * Counts total no of editable cells and sets up filters
         */
        var setUpColumnHeaders = function(){
            var noOfEditable, colVal, row;
            //filterConditionOptionsSetup
            for (var colKey in $scope.bulkEdit.sourceData.headerLabels) {
                noOfEditable = 0;
                colVal = $scope.bulkEdit.sourceData.headerLabels[colKey];
                colVal.editableRowIdSet = {};
                //Sets the filters initial value
                colVal.filter = { condition: $scope.filterConditionOptions[colVal.dataFormatType][0].id, value:'' };
                //$scope.filterConditionOptionsSetup
                //console.log( $scope.bulkEdit.sourceData.headerLabels[key].editable );
                if( colVal.editable ) {
                    for (var dataRowIdx in $scope.bulkEdit.sourceData.dataList) {
                        //console.log( $scope.bulkEdit.sourceData.dataList[dataRowIdx][key] );
                        row = $scope.bulkEdit.sourceData.dataList[dataRowIdx];
                        //console.log('row',row);
                        if (row[colKey].editable) {
                            //console.log('row.id',row.id);
                            colVal.editableRowIdSet[row.id.value] = true;
                            noOfEditable++;
                        }
                    }
                }
                colVal.noOfEditable = noOfEditable;
            }
        };

        var EMPTY_LIST = [undefined,'',null];
        var isEmpty = function(value){
            for(var idx in EMPTY_LIST){
                if(EMPTY_LIST[idx]===value){
                    return true;
                }
            }
            return false;
        };

        var convertValueToType = function(value, type){
            var convertedType;
            switch (type) {
                case 'STRING':
                    convertedType = value;
                    break;
                case 'MONETARY_WITH_RATE':
                case 'NUMBER':
                case 'ID':
                    convertedType = Number(value);
                    break;
                case 'DATE':
                case 'DATE_TIME':
                case 'TIME':
                    convertedType = Date.parse(value);
                    break;
            }
            return convertedType;
        };

        /**
         *
         * example: {condition: "<>EQ", value: 7, filterType: "NUMBER"}
         * @param filterForColumn {condition: String, value: 7, filterType: "NUMBER"}
         */
        var filterCell = function(colKey, row){
            var cellMatch = false;
            var colVal = $scope.bulkEdit.sourceData.headerLabels[colKey];
            var filterForColumn = colVal.filter;
            var filterValue;
            var cellValue;
            if(isEmpty(filterForColumn.value)){
                cellMatch = true;
            } else {
                //note: Maybe in future may need to separate dataFormatType and filterType
                filterValue = convertValueToType(filterForColumn.value, colVal.dataFormatType);
                cellValue = row[colKey].value;
                //row.value
                try {
                    switch (filterForColumn.condition) {
                        case 'EQ':
                            //should cast data Type
                            if(isNaN(filterValue)) {
                                cellMatch = (filterValue.toUpperCase() === cellValue.toUpperCase());
                                break;
                            }else{
                                cellMatch = (filterValue === cellValue);
                                break;
                            }
                        case '<>EQ':
                            if(isNaN(filterValue)) {
                                cellMatch = (filterValue.toUpperCase() !== cellValue.toUpperCase());
                                break;
                            }else{
                                cellMatch = (filterValue !== cellValue);
                                break;
                            }
                        case 'BF':
                            cellMatch = (filterValue > cellValue);
                            break;
                        case 'AFT':
                            cellMatch = (filterValue < cellValue);
                            break;
                        case 'GT':
                            cellMatch = (filterValue < cellValue);
                            break;
                        case 'LT':
                            cellMatch = (filterValue > cellValue);
                            break;
                        case 'C':
                            cellMatch = (cellValue.toUpperCase().includes(filterValue.toUpperCase()));
                            break;
                        case '<>C':
                            cellMatch = (!cellValue.toUpperCase().includes(filterValue.toUpperCase()));
                            break;
                    }
                }catch(err){
                    log('err in filterCell',err);
                }
            }
            log('filterCell',[cellValue, filterValue, filterForColumn, cellMatch]);
            return cellMatch;
        };

        var filterRow = function(row){
            var rowMatch;
            for (var colKey in $scope.bulkEdit.sourceData.headerLabels) {
                //$scope.sourceData.headerLabels[colKey].filter = {condition: $scope.filterConditionOptionsSetup[0].id, value:''};
                log('colKey', colKey);
                if(filterCell(colKey, row)) {
                    rowMatch = true;
                } else {
                    //don't filter for rest of columns
                    rowMatch = false;
                    break;
                }
            }
            //if(!rowMatch && colKey=='accountNumber') log('whoooooop','');
            log('filterRow',[row,rowMatch]);
            return rowMatch;
        };

        var filterData = function(){
            //$scope.bulkEdit.filteredDataList = $scope.bulkEdit.sourceData.dataList.slice(0);
            //filterConditionOptionsSetup
            var filteredDataList = [];//$scope.bulkEdit.sourceData.dataList.slice(0)
            var row;
            for(var rowIdx in $scope.bulkEdit.sourceData.dataList) {
                row = $scope.bulkEdit.sourceData.dataList[rowIdx];
                if( filterRow(row) ) {
                    filteredDataList.push(row);
                }
            }
            $scope.bulkEdit.filteredDataList = filteredDataList;
        };

        var getDataModel = function(dataURL, getBulkSizeUrl){
            $scope.ajaxState = 'LOADING';
            ajaxCall.getData( getBulkSizeUrl ).then(function(response){
                log('timeEstimations',response.data);
                $scope.ajaxState = 'LOADING_PROGRESS';

                $scope.progressBar = progressBarService.init($scope);
                progressBarService.addBar('loadBulkData',response.data.averageTime);
                progressBarService.start('loadBulkData');

                ajaxCall.getData( dataURL ).then(function(response){
                    progressBarService.stop('loadBulkData');
                    $scope.bulkEdit.sourceData = response.data;
                    if( $scope.bulkEdit.sourceData.dataList!==undefined){
                        formatRowData(true);
                        if(!isAjaxOrDataFailure()) {
                            //makes an array of references. e.g. modifying the original source data will modify, filtered model
                            $scope.bulkEdit.filteredDataList = $scope.bulkEdit.sourceData.dataList.slice(0);
                            $scope.ajaxState = 'COMPLETED';
                            setUpColumnHeaders();
                        }
                    } else {
                        reportAjaxOrDataFailure('$scope.bulkEdit.sourceData.dataList is undefined');
                    }
                },function(response){
                    console.log('oops 2',response.data);
                    reportAjaxOrDataFailure('AJAX failed',response.status +' '+ response.statusText);
                });

            },function(response){
                console.log('oops 1',response.data);
                reportAjaxOrDataFailure('AJAX failed',response.status +' '+ response.statusText);
            });
        };

        var isAjaxOrDataFailure = function(){
            return ($scope.ajaxState == 'FAILED');
        };

        var reportAjaxOrDataFailure = function(consoleWarning, ajaxFailResponse){
            if(consoleWarning){ console.warn(consoleWarning); }
            $scope.ajaxState = 'FAILED';
            $scope.ajaxFailResponse = ajaxFailResponse ? ajaxFailResponse : 'Data response is empty or an invalid format' ;
        };

        /**
         * Performs various manipulations on the source data to prepare it for use.
         * @param initialSetup
         */
        var formatRowData = function(initialSetup){
            log('formatRowData(initialSetup)',initialSetup);
            var row, colVal, cell, rowId, edited;
            for(var rowIdx in $scope.bulkEdit.sourceData.dataList) {
                row = $scope.bulkEdit.sourceData.dataList[rowIdx];
                rowId = row.id.value;
                edited = false;
                for (var colKey in $scope.bulkEdit.sourceData.headerLabels) {
                    colVal = $scope.bulkEdit.sourceData.headerLabels[colKey];
                    cell = row[colKey];
                    if(colVal){
                        if(!cell.formattedValue || !initialSetup) {
                            cell.formattedValue = formattedValue(cell, colVal.dataFormatType);
                        }
                        if(initialSetup) {
                            cell.value = parseValue(cell, colVal.dataFormatType);
                            //STORING original value - reverts and is edited
                            cell.origValue = cell.value;
                        }
                        //Identify if cell has changed. Once cell is flagged as change, it will no longer check 2nd part of if condition.
                        if(colVal.editable && cell.editable) {
                            edited = (edited || cell.origValue !== cell.value);
                        }
                    } else {
                        reportAjaxOrDataFailure('Mismatch of headerLabels and dataList values. There may be header labels defined with no matching cell. Failed on colKey:'+colKey);
                        break;
                    }
                }
                editSet(rowId, edited);
            }
        };
        /**
         *
         * @param filterConditionOptionsSetup
         */
        var setUpFilterConditionOptions = function(filterConditionOptionsSetup){
            $scope.filterConditionOptionsSetup = filterConditionOptionsSetup;
            var filterConditionOptionsSetupObj, filterType;
            for(var foIdx in $scope.filterConditionOptionsSetup){
                filterConditionOptionsSetupObj = $scope.filterConditionOptionsSetup[foIdx];
                log('filterConditionOptionsSetupObj',filterConditionOptionsSetupObj);
                for(var ftIdx in filterConditionOptionsSetupObj.filterType){
                    filterType = filterConditionOptionsSetupObj.filterType[ftIdx];
                    log('filterType',filterType);
                    if(!$scope.filterConditionOptions[filterType]) $scope.filterConditionOptions[filterType] = [];
                    $scope.filterConditionOptions[filterType].push(filterConditionOptionsSetupObj);
                }
            }
            log('setUpFilterConditionOptions',$scope.filterConditionOptions);
        };
        /**
         *
         * @param colKey
         * @param colVal
         * @param row
         * @returns {*}
         */
        var cellClass = function(colKey, colVal, row){
            var css;
            if( !isCellEditable(colKey, colVal, row) ){
                css = $scope.css.disabled;
                if( isCellHighlightingEntriesAndEntryMade(colKey,row) ) {
                    css = $scope.css.entryHighlights; //replace disabled effect as text too muted
                }
            } else {
                css = $scope.css.editable;
                if(isCellSelected(colKey, row.id.value)){
                    css += ' ' + $scope.css.highlight;
                } else if( isCellEdited(colKey, row) ){
                    css += ' ' + $scope.css.edited;
                } else if( isCellHighlightingEntriesAndEntryMade(colKey,row) ) {
                    css += ' ' + $scope.css.entryHighlights;
                }
            }
            return css;
        };
        /**
         *
         * @param value
         * @param fractionDigits
         * @returns {string}
         */
        var formatCurreny = function(value, fractionDigits){
            var mutiplier = Math.pow(10, fractionDigits);
            var formattedCurrency = parseFloat(Math.round(value * mutiplier) / mutiplier).toFixed(fractionDigits);
            log('formatCurreny',[value,fractionDigits,formattedCurrency]);
            return formattedCurrency;
        };
        var formattedValue = function(cell, dataFormatType){
            var formattedValue;
            switch(dataFormatType){
                case 'MONETARY_WITH_RATE':
                    formattedValue = cell.symbol + formatCurreny(cell.value, cell.fractionDigits) + ' ' + cell.rate;
                    break;
                case 'DATE':
                    formattedValue = $filter('date')(cell.value,"dd/MM/yyyy");
                    break;
                default:
                    formattedValue = cell.value;
            }
            log('formattedValue',formattedValue);
            return formattedValue
        };

        var parseValue = function(cell, dataFormatType){
            var parsedValue;
            switch(dataFormatType){
                case 'DATE':
                    parsedValue = Date.parse(cell.value) ? Date.parse(cell.value):'';
                    break;
                default:
                    parsedValue = cell.value;
            }
            return parsedValue;
        };

        /**
         * Looping keys and when finding a match running a user defined function
         * @param rowIdSet row id's to loop
         * @param myFunction
         * @param passedDataModel
         */
        var loopData = function(rowIdSet, myFunction, passedDataModel){
            keyValueObjectService.loopData( rowIdSet, $scope.bulkEdit.sourceData.dataList, $scope.colKey, myFunction, passedDataModel );
        };

        var queueChanges = function(){
            log('queueChanges', 'boo');
            var MAX_ROW_SIZE = 400;
            var editedRef = $scope.bulkEdit.user.edited;
            $scope.ajaxState = 'LOADING';
            var rowIdSetList = keyValueObjectService.splitKeys( editedRef.rowIdSet, MAX_ROW_SIZE, true );

            editedRef.rowPartList = [];
            for (var idx=0, l = rowIdSetList.length; idx < l; idx++) {
                editedRef.rowList = [];
                loopData( rowIdSetList[idx], commitResponseData, null );
                editedRef.rowPartList.push( editedRef.rowList );
            }
            recursiveQueueChanges(editedRef.rowPartList,0);
        };

        var recursiveQueueChanges = function(rowPartList, idx){
            console.log('recursiveQueueChanges()',idx);
            if( idx < rowPartList.length ) {
                ajaxCall.getData($scope.queueDataUrl, {rowList: rowPartList[idx]}).then(function (response) {
                    console.log(response.data, response.data);
                    if (!response.data.redirect) {
                        xmsNotificationFactory.addObj({id: 'bulky'+idx.toString(), type: 'danger', bodyHtml: response.data.message});
                    }
                    idx++;
                    recursiveQueueChanges(rowPartList,idx);
                }, function (response) {
                    console.log('AJAX Fail:', response.data);
                    xmsNotificationFactory.addObj({
                        id: 'bulkServerSideFail',
                        type: 'danger',
                        bodyHtml: response.status + ' ' + response.statusText
                    });
                    $scope.ajaxState = 'COMPLETED';
                });
            } else {
                window.location.href = $scope.monitorProgressUrl;
                $scope.ajaxState = 'COMPLETED';
            }
        };

        /**
         * Looper Function - Commits the response data to the source data and closes the modal
         * @param row
         * @param cell
         * @param responseData
         */
        var commitResponseData = function(row, cell, passedData){
            log('commitResponseData()', passedData);
            $scope.bulkEdit.user.edited.rowList.push(row);
        };


        /**
         * Check if all editable rows are selected
         */
        $scope.isAllSelected = function(colKey, colVal, rows){
            var cellCount = countEditableAndSelectedCells(colKey, colVal, rows);
            return (cellCount.editable == cellCount.selected && cellCount.editable!=0);
        }

        $scope.isAnyFiltered = function(){
            // check if all properties bulkEditModel.filter are empty / unset
            var filtersObj = $scope.bulkEditModel.filter;
            for (var key in filtersObj) {
                if (angular.isDefined(filtersObj[key]) && filtersObj[key] != "") {
                    return true;
                }
            }
            return false;
        }

        $scope.filterData = function(){
            filterData();
        };

        $scope.$watchCollection('bulkEditModel.filter', function(newVal, oldVal){
            if( !angular.equals(newVal, oldVal) ){
                $timeout(filterData);
            }
        });

        /**
         * Performs either: single cell selection / all visible cell selections in column / all visible cell deslection
         * @param colKey ~ key of the column of selected cell
         * @param colVal ~ column object rules of selected cell
         * @param row ~ row object rules of selected cell
         */
        $scope.cellClick = function(colKey, colVal, row) {
            toggleCell(colKey, colVal, row);
            log('cellClick()', [colKey, colVal, row]);
            //formModel.selectedColId = colKey
        };

        /**
         * Selects all the visible rows
         * @param displayedRows
         */
        $scope.isSameColumn = function(colKey){
            //console.log('isSameColumn');
            return isSameColumn(colKey);
        };

        /**
         * Selects all the visible rows
         * @param rows ~ can be displayedRows or all rows
         */
        $scope.toggleAllCells = function(colKey, colVal, rows){
            toggleAllCells(colKey, colVal, rows);
        };

        /**
         * Counts how many rows are selected
         * @returns Number
         */
        $scope.countCurrentSelection = function(){
            return countCurrentSelection();
        };

        /**
         * Counts how many rows have been edited
         * @returns Number
         */
        $scope.countEditedRows = function(){
            return countEditedRows();
        };

        $scope.cellClass = function(colKey, colVal, row){
            return cellClass(colKey, colVal, row)
        };
        /**
         * Initialises all the setup properties. Trys to maintain flexibility with non booking specific functionality or naming
         * @param DEBUG
         * @param rowsPerPage
         * @param dataURL
         * @param queueDataUrl
         * @param monitorProgressUrl
         * @param css
         * @param filterConditionOptionsSetup
         */
        $scope.init = function(DEBUG, rowsPerPage, dataURL, queueDataUrl, monitorProgressUrl, getBulkSizeUrl, css, filterConditionOptionsSetup){
            console.log('BulkEditCtrl.init()',DEBUG, dataURL, getBulkSizeUrl);
            $scope.DEBUG = DEBUG;
            $scope.queueDataUrl = queueDataUrl;
            $scope.monitorProgressUrl = monitorProgressUrl;
            $scope.rowsPerPage = rowsPerPage;
            if(!css) {
                //use default bootstrap css
                css = {highlight: 'highlight', editable: 'editable', disabled:'disabled', edited:'success', entryHighlights:'bg-danger text-danger'};
                console.log('css is undefined using default bootstrap css:',css);
            }
            $scope.css = css;
            getDataModel(dataURL, getBulkSizeUrl);
            setUpFilterConditionOptions(filterConditionOptionsSetup);
            clearAllSelectedCells();
        };

        $scope.reformatRowData = function(){
            formatRowData(false);
            filterData();
            clearAllSelectedCells();
        };
        /*
        $scope.deleteRow = function(){
            var idx = $scope.bulkEdit.sourceData.dataList.length-1;
            if (idx > -1) {
                $scope.bulkEdit.sourceData.dataList.splice(idx, 1);
            }
        }
        */
        $scope.edit = function(colKey, colVal, editingAll){
          log('edit(colKey, colVal, editingAll)',[colKey, colVal, editingAll]);
            selectCol(colKey, colVal);
            $scope.bulkEdit.removeData = false;
            $scope.bulkEdit.editableField = '';
            $scope.bulkEdit.user.selected.editingAll = editingAll;
        };

      $scope.remove = function(colKey, colVal, editingAll){
        log('remove(colKey, colVal, editingAll)',[colKey, colVal, editingAll]);
        selectCol(colKey, colVal);
        $scope.bulkEdit.removeData = true;
        $scope.bulkEdit.editableField = '';
        $scope.bulkEdit.user.selected.editingAll = editingAll;
      };

        /**
         * Queues all the changes
         */
        $scope.queueChanges = function($event){
            $event.preventDefault();
          // Validate activity and remuneration pairs in all edited rows
          const hasInvalidActivityPairs = $scope.bulkEdit.filteredDataList.some(row => {
            return isActivityRemunerationMismatch(row);
          });

          if (hasInvalidActivityPairs) {
            $scope.activityFieldState = 'ACT_VALIDATION_FAILED';
            return;
          }
          queueChanges();
        };

      function isActivityRemunerationMismatch(row) {
        const pairs = [
          { activity: 'activity1', remuneration: 'activity1Remuneration' },
          { activity: 'activity2', remuneration: 'activity2Remuneration' },
          { activity: 'activity3', remuneration: 'activity3Remuneration' }
        ];

        return pairs.some(pair => {
          const hasActivity = row[pair.activity] && row[pair.activity].value;
          const hasRemuneration = row[pair.remuneration] && row[pair.remuneration].value;

          // Invalid if one exists without the other
          return (hasActivity && !hasRemuneration) || (!hasActivity && hasRemuneration);
        });
      }

      /**
       * Debug function to log all columns and their values for a row
       */
      $scope.debugRowColumns = function(row) {
        console.log('=== DEBUG ROW COLUMNS ===');
        for (let colKey in row) {
          const cell = row[colKey];
          if (cell && cell.value !== undefined) {
            console.log(`${colKey}: ${cell.value}`);
          }
        }
        console.log('========================');
      };

      /**
       * Check if a specific cell has a mismatch with its corresponding pair
       * Returns true only if THIS cell is empty while its pair has a value
       */
      function isCellActivityRemunerationMismatch(row, colKey) {
        const pairs = [
          { activity: 'activity1', remuneration: 'activity1Remuneration' },
          { activity: 'activity2', remuneration: 'activity2Remuneration' },
          { activity: 'activity3', remuneration: 'activity3Remuneration' }
        ];

        try {
          const result = pairs.some(pair => {
            // Check if current cell is part of this pair
            if (pair.activity === colKey || pair.remuneration === colKey) {
              // Safely check if cells exist and get their values
              const activityCell = row[pair.activity];
              const remunerationCell = row[pair.remuneration];

              // Get the actual value from the cell - handle different possible structures
              const getValueFromCell = (cell) => {
                if (!cell) return '';
                // Try different possible value properties
                if (cell.value !== undefined && cell.value !== null) {
                  return String(cell.value).trim();
                } else if (cell.formattedValue !== undefined && cell.formattedValue !== null) {
                  return String(cell.formattedValue).trim();
                } else if (typeof cell === 'string') {
                  return String(cell).trim();
                }
                return '';
              };

              const hasActivity = getValueFromCell(activityCell) !== '';
              const hasRemuneration = getValueFromCell(remunerationCell) !== '';

              // Highlight THIS cell if it's empty and its pair has a value
              if (pair.activity === colKey) {
                // Current cell is activity - highlight if empty and remuneration is filled
                const shouldHighlight = !hasActivity && hasRemuneration;
                if ($scope.DEBUG) {
                  console.log(`[Activity Check] ${colKey}: activity="${getValueFromCell(activityCell)}" (${hasActivity}), remuneration="${getValueFromCell(remunerationCell)}" (${hasRemuneration}), shouldHighlight=${shouldHighlight}`);
                }
                return shouldHighlight;
              } else if (pair.remuneration === colKey) {
                // Current cell is remuneration - highlight if empty and activity is filled
                const shouldHighlight = !hasRemuneration && hasActivity;
                if ($scope.DEBUG) {
                  console.log(`[Remuneration Check] ${colKey}: activity="${getValueFromCell(activityCell)}" (${hasActivity}), remuneration="${getValueFromCell(remunerationCell)}" (${hasRemuneration}), shouldHighlight=${shouldHighlight}`);
                }
                return shouldHighlight;
              }
            }
            return false;
          });
          return result;
        } catch(err) {
          console.error('Error in isCellActivityRemunerationMismatch', err);
          log('Error in isCellActivityRemunerationMismatch', err);
          return false;
        }
      }

      /**
       * Expose isCellActivityRemunerationMismatch to scope for template use
       */
      $scope.isCellActivityRemunerationMismatch = function(row, colKey) {
        return isCellActivityRemunerationMismatch(row, colKey);
      };

      /**
       * Expose isActivityRemunerationMismatch to scope for template use
       */
      $scope.isActivityRemunerationMismatch = function(row) {
        return isActivityRemunerationMismatch(row);
      };
    };
    BulkEditCtrl.$inject = ['$scope', '$compile', 'ajaxCall', '$filter', '$timeout', 'xmsNotificationFactory', 'keyValueObjectService', 'progressBarService'];
    angular.module('app').controller('BulkEditCtrl', BulkEditCtrl);
}());
